// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Wp0d4T_7rsHsKKgvUve5 {
  margin-left: auto;
  margin-right: auto;
  margin-top: 2.5rem;
  height: 85vh;
  border-radius: 20px;
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  padding-top: 2.5rem;
  padding-bottom: 0.75rem;
}

.pKZTn72aycfNu2BPUxBH {
  margin-bottom: 1.5rem;
  padding-left: 1.75rem;
  font-size: 1.125rem;
  line-height: 1.75rem;
  font-weight: 600;
}

.xoVAA64Bdd_mwxPm3l8g {
  margin-top: 1.5rem;
  margin-bottom: 0.5rem;
  font-size: 1.25rem;
  line-height: 1.75rem;
  font-weight: 600;
  --tw-text-opacity: 1;
  color: rgb(26 26 26 / var(--tw-text-opacity, 1));
}

.Fxve5vJMIO1yG3EMgmqI {
  margin-bottom: 1rem;
  font-size: 1rem;
  line-height: 1.5rem;
  line-height: 1.625;
  --tw-text-opacity: 1;
  color: rgb(94 94 94 / var(--tw-text-opacity, 1));
}

.u4Kl8ZFwzGCKo3JYVpR2 {
  display: flex;
  min-height: 100vh;
  justify-content: center;
  padding-left: 8rem;
  padding-right: 8rem;
  background: linear-gradient(
    116.81deg,
    rgba(188, 211, 228, 0.25) -7.65%,
    rgba(255, 255, 255, 0.25) 71.29%
  );
}

.Eql1hUPpFOwQtaNR6pX1 {
  height: 68vh;
}

.Eql1hUPpFOwQtaNR6pX1 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1rem * var(--tw-space-y-reverse));
}

.Eql1hUPpFOwQtaNR6pX1 {
  overflow-y: auto;
  font-family: Noto Sans;
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 400;
  line-height: 1.625;
  --tw-text-opacity: 1;
  color: rgb(26 26 26 / var(--tw-text-opacity, 1));
  padding-left: 1.75rem;
  padding-right: 1rem;
}

.Eql1hUPpFOwQtaNR6pX1 h2 {
  font-weight: 600;
}

.Eql1hUPpFOwQtaNR6pX1 a {
  text-decoration-line: underline;
}

.AyKtO_kCbmZKMZiSuuHX {
  height: 38px;
  width: 120px;
  --tw-bg-opacity: 1;
  background-color: rgb(0 130 202 / var(--tw-bg-opacity, 1));
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

.AyKtO_kCbmZKMZiSuuHX:hover {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(0 130 202 / var(--tw-bg-opacity, 1)) !important;
  --tw-text-opacity: 1 !important;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1)) !important;
}

._7bYAQ6IIrbiltDAhoVai {
  display: flex;
  justify-content: flex-end;
  padding-right: 2rem;
}

@media (max-width: 767px) {
  ._7bYAQ6IIrbiltDAhoVai {
    display: none;
  }

  .u4Kl8ZFwzGCKo3JYVpR2 {
    padding: 16px;
  }

  .u4Kl8ZFwzGCKo3JYVpR2 > div {
    width: 100%;
    min-width: 0;
  }

  .Wp0d4T_7rsHsKKgvUve5 {
    height: auto;
    margin-top: 0;
    padding: 24px 16px;
  }

  .pKZTn72aycfNu2BPUxBH {
    padding-left: 0;
  }

  .Eql1hUPpFOwQtaNR6pX1 {
    height: auto;
    overflow: visible;
    padding: 0;
    font-size: 16px;
  }

  .u4Kl8ZFwzGCKo3JYVpR2 > div > div:last-child {
    padding-right: 0;
    margin-top: 16px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/PrivacyPolicy/PrivacyPolicy.module.css"],"names":[],"mappings":"AACE;EAAA,iBAAqE;EAArE,kBAAqE;EAArE,kBAAqE;EAArE,YAAqE;EAArE,mBAAqE;EAArE,kBAAqE;EAArE,4DAAqE;EAArE,oBAAqE;EAArE,qBAAqE;EAArE,mBAAqE;EAArE;AAAqE;;AAIrE;EAAA,qBAAsC;EAAtC,qBAAsC;EAAtC,mBAAsC;EAAtC,oBAAsC;EAAtC;AAAsC;;AAItC;EAAA,kBAAoD;EAApD,qBAAoD;EAApD,kBAAoD;EAApD,oBAAoD;EAApD,gBAAoD;EAApD,oBAAoD;EAApD;AAAoD;;AAIpD;EAAA,mBAAmD;EAAnD,eAAmD;EAAnD,mBAAmD;EAAnD,kBAAmD;EAAnD,oBAAmD;EAAnD;AAAmD;;AAInD;EAAA,aAA6C;EAA7C,iBAA6C;EAA7C,uBAA6C;EAA7C,kBAA6C;EAA7C,mBAA6C;EAC7C;;;;;AAD6C;;AAS7C;EAAA;AAAsG;;AAAtG;EAAA,uBAAsG;EAAtG,4DAAsG;EAAtG;AAAsG;;AAAtG;EAAA,gBAAsG;EAAtG,sBAAsG;EAAtG,mBAAsG;EAAtG,oBAAsG;EAAtG,gBAAsG;EAAtG,kBAAsG;EAAtG,oBAAsG;EAAtG,gDAAsG;EACtG,qBAAqB;EACrB;AAFsG;;AAMtG;EAAA;AAAoB;;AAIpB;EAAA;AAAgB;;AAIhB;EAAA,YAA2D;EAA3D,YAA2D;EAA3D,kBAA2D;EAA3D,0DAA2D;EAA3D,oBAA2D;EAA3D,qBAA2D;EAA3D,mBAA2D;EAA3D,sBAA2D;EAA3D,oBAA2D;EAA3D;AAA2D;;AAI3D;EAAA,6BAAgC;EAAhC,qEAAgC;EAAhC,+BAAgC;EAAhC;AAAgC;;AAIhC;EAAA,aAA4B;EAA5B,yBAA4B;EAA5B;AAA4B;;AAG9B;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,iBAAiB;IACjB,UAAU;IACV,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;EAClB;AACF","sourcesContent":[".container {\n  @apply mx-auto px-6 pt-10 pb-3 bg-white rounded-[20px] h-[85vh] mt-10;\n}\n\n.title {\n  @apply text-lg font-semibold mb-6 pl-7;\n}\n\n.subtitle {\n  @apply text-xl font-semibold mt-6 mb-2 text-gray-700;\n}\n\n.text {\n  @apply text-base leading-relaxed text-gray-600 mb-4;\n}\n\n.gradientBg {\n  @apply flex justify-center min-h-screen px-32;\n  background: linear-gradient(\n    116.81deg,\n    rgba(188, 211, 228, 0.25) -7.65%,\n    rgba(255, 255, 255, 0.25) 71.29%\n  );\n}\n\n.policyContent {\n  @apply space-y-4 text-gray-700 leading-relaxed text-sm font-normal overflow-y-auto h-[68vh] font-inter;\n  padding-left: 1.75rem;\n  padding-right: 1rem;\n}\n\n.policyContent h2 {\n  @apply font-semibold;\n}\n\n.policyContent a {\n  @apply underline;\n}\n\n.applyButton {\n  @apply bg-secondary text-white px-6 py-2 w-[120px] h-[38px];\n}\n\n.applyButton:hover {\n  @apply !bg-secondary !text-white;\n}\n\n.backToLogin {\n  @apply flex justify-end pr-8;\n}\n\n@media (max-width: 767px) {\n  .backToLogin {\n    display: none;\n  }\n\n  .gradientBg {\n    padding: 16px;\n  }\n\n  .gradientBg > div {\n    width: 100%;\n    min-width: 0;\n  }\n\n  .container {\n    height: auto;\n    margin-top: 0;\n    padding: 24px 16px;\n  }\n\n  .title {\n    padding-left: 0;\n  }\n\n  .policyContent {\n    height: auto;\n    overflow: visible;\n    padding: 0;\n    font-size: 16px;\n  }\n\n  .gradientBg > div > div:last-child {\n    padding-right: 0;\n    margin-top: 16px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Wp0d4T_7rsHsKKgvUve5`,
	"title": `pKZTn72aycfNu2BPUxBH`,
	"subtitle": `xoVAA64Bdd_mwxPm3l8g`,
	"text": `Fxve5vJMIO1yG3EMgmqI`,
	"gradientBg": `u4Kl8ZFwzGCKo3JYVpR2`,
	"policyContent": `Eql1hUPpFOwQtaNR6pX1`,
	"applyButton": `AyKtO_kCbmZKMZiSuuHX`,
	"backToLogin": `_7bYAQ6IIrbiltDAhoVai`
};
export default ___CSS_LOADER_EXPORT___;
